export const PERMISSIONS = {
  SM_CAN_READ_SITES: 'SM_CAN_READ_SITES',
  SM_CAN_CREATE_SITE: 'SM_CAN_CREATE_SITE',
  SM_CAN_UPDATE_SITE: 'SM_CAN_UPDATE_SITE',
  SM_CAN_DELETE_SITE: 'SM_CAN_DELETE_SITE',

  SM_CAN_READ_VARIETIES: 'SM_CAN_READ_VARIETIES',
  SM_CAN_CREATE_VARIETY: 'SM_CAN_CREATE_VARIETY',
  SM_CAN_UPDATE_VARIETY: 'SM_CAN_UPDATE_VARIETY',
  SM_CAN_DELETE_VARIETY: 'SM_CAN_DELETE_VARIETY',

  SM_CAN_READ_WAVES: 'SM_CAN_READ_WAVES',
  SM_CAN_CREATE_WAVE: 'SM_CAN_CREATE_WAVE',
  SM_CAN_UPDATE_WAVE: 'SM_CAN_UPDATE_WAVE',
  SM_CAN_DELETE_WAVE: 'SM_CAN_DELETE_WAVE',

  SM_CAN_READ_PRODUCTIONS: 'SM_CAN_READ_PRODUCTIONS',
  SM_CAN_CREATE_PRODUCTION: 'SM_CAN_CREATE_PRODUCTION',
  SM_CAN_UPDATE_PRODUCTION: 'SM_CAN_UPDATE_PRODUCTION',
  SM_CAN_DELETE_PRODUCTION: 'SM_CAN_DELETE_PRODUCTION',

  SM_CAN_READ_DELINTAGES: 'SM_CAN_READ_DELINTAGES',
  SM_CAN_CREATE_DELINTAGE: 'SM_CAN_CREATE_DELINTAGE',
  SM_CAN_UPDATE_DELINTAGE: 'SM_CAN_UPDATE_DELINTAGE',
  SM_CAN_DELETE_DELINTAGE: 'SM_CAN_DELETE_DELINTAGE',

  SM_CAN_CREATE_REPORT: 'SM_CAN_CREATE_REPORT',
  SM_CAN_CREATE_REPORT_METRIC: 'SM_CAN_CREATE_REPORT_METRIC',

  SM_CAN_READ_TRANSFERS: 'SM_CAN_READ_TRANSFERS',
  SM_CAN_CREATE_TRANSFER: 'SM_CAN_CREATE_TRANSFER',
  SM_CAN_UPDATE_TRANSFER: 'SM_CAN_UPDATE_TRANSFER',
  SM_CAN_DELETE_TRANSFER: 'SM_CAN_DELETE_TRANSFER',

  SM_USER: 'SM_USER',
  SM_SUPERVISOR: 'SM_SUPERVISOR',
} as const;

export type AppPermission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
